<template>
  <div class="certificateAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回证书列表</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="证书名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入证书名称" class="item-input" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item tem label="证书编号" prop="num">
          <el-input v-model="ruleForm.num" placeholder="请输入证书编号" class="item-input" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item style="margin-right:30px;" label="产品展示图" prop="imageUris" ref="imageUris">
          <upload-file ref="uploading" :accept="accept" upTypes="2" :fileList="fileListTemp" :clears="clears"
            @outputFile="getFile" @removeFile="removeFile"></upload-file>
        </el-form-item>

        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
        <el-form-item class="editor-height">
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:certificateAdd
   *@Description:御琥阁产品证书-编辑/新增
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import UploadFile from '../../components/upload_file.vue'

  export default {
    data() {
      return {
        clears: false, // 清空按钮
        accept: '.jpg, .jpeg, .png',
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        saveData: '',
        isDisabled: true, // 保存的可点击
        isFlag: false, // 编辑:true 新增：false
        fileList: [], // 文件列表
        fileListTemp: [], // 文件列表
        rules: {
          name: [{
            required: true,
            message: '请输入证书名称',
            trigger: 'blur'
          }],
          num: [{
            required: true,
            message: '请输入证书编号',
            trigger: 'blur'
          }],
          imageUris: [{
            required: true,
            message: '请上传证书图片',
            trigger: 'change'
          }],

        },
        ruleForm: {
          id: '', // 序号
          name: '', // 证书名称
          imageUris: [], // 证书图片
          num: '', // 证书编号
        },
      }
    },
    components: {
      'upload-file': UploadFile
    },
    destroyed() {
      window.localStorage.setItem('yhgCertificate1', JSON.stringify(this.ruleForm))
    },
    created() {
      // 判断编辑与新增
      this.isFlag = this.$route.query.flag
      if (window.localStorage.getItem('yhgCertificate1')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('yhgCertificate1'))
        this.fileList = JSON.parse(this.ruleForm.PhotoUrls)
        this.fileListTemp = this.ruleForm.PhotoUrls
      } else {
        if (this.$route.query.object) {
          console.log(this.$route.query.object)
          // 编辑
          console.log('编辑')
          this.getData()
        } else {
          // 新增
          console.log('新增')
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      getFile(e) {
        this.fileList.push({
          name: '',
          url: e
        })
        this.ruleForm.imageUris = this.fileList
        this.isDisabled = false
      },
      removeFile(e) {
        this.isDisabled = false
        let list1 = []
        this.fileList = list1
        this.ruleForm.imageUris = this.fileList
        this.fileListTemp = JSON.parse(JSON.stringify(list1))
      },
      // 编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        // 这是用来双向绑定,由于字段名称不同，所以一一对应
        this.ruleForm.id = this.$route.query.object.a_id
        this.ruleForm.name = this.$route.query.object.a_title2
        this.ruleForm.num = this.$route.query.object.bianhao
        this.ruleForm.imageUris = this.$route.query.object.a_pic

        this.fileList.push({
          name: '',
          url: this.$route.query.object.a_pic
        })

        this.fileListTemp = JSON.parse(JSON.stringify(this.fileList))
        console.log('getData', this.ruleForm)
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'certificateList'
        })
      },
      // 保存
      save(formName) {
        console.log('save', this.ruleForm)
        let params = {}
        if (this.isFlag) {
          params.Id = this.ruleForm.id
        }
        params.a_title2 = this.ruleForm.name
        params.bianhao = this.ruleForm.num
        let filesList = []
        if (this.fileList.length > 0) {
          for (let i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i] && this.fileList[i].url) {
              filesList.push(this.fileList[i].url)
            } else {
              filesList.push(this.fileList[i])
            }
          }
        }
        params.a_pic = filesList.toString()
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            // 新增
            if (!params.Id) {
              this.$post('/nZhengshu', params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'certificateList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/nZhengshu/${this.ruleForm.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'certificateList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.$refs.ruleForm.clearValidate()
        this.clears = true
        this.fileList = []
        this.ruleForm.name = ''
        this.ruleForm.num = ''
      },

    },
  }
</script>

<style lang="scss">
  .certificateAdd {
    .item-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }

    .replyCon {
      width: 600px;
    }

    .editor-height {
      height: 150px;
    }
  }
</style>